// src/pages/GeriBildirimlerPage.js
import { TextField } from "react-admin";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  List,
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  ImageField,
  TopToolbar,
  ExportButton,
  useNotify,
  useRedirect,
  useListContext,
  SaveButton,
DeleteButton,
  Toolbar as RaToolbar,
  RecordContextProvider,
  useRefresh,
  useUpdate,
  useDataProvider,
  useRecordContext,
} from "react-admin";
import GlobalStyles from "@mui/material/GlobalStyles";
import {
  Badge,
  Box,
  Chip,
  Grid,
  Button,
  Divider,
  Paper,
  Stack,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  TextField as TextFieldMUI,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";


/* ================= UI DİLİ ================= */
const mapStatusLabel = (status, TT) => {
  if (status === "Yeni") return TT.statuses.yeni;
  if (status === "İnceleniyor") return TT.statuses.inceleniyor;
  if (status === "Çözüldü") return TT.statuses.cozuldu;
  return status;
};


const ALLOWED = ["tr", "en", "de"];
const T = {
  tr: {
    pageTitle: "📝 Geri Bildirimler",
    detailTitle: "Geri Bildirim Detayı",
    filters: { durum: "Durum" },
    fields: {
      sender: "Gönderen",
      category: "Kategori",
      title: "Başlık",
      desc: "Açıklama",
      image: "Ekli Görsel",
      status: "Durum",
    },
    statuses: { yeni: "Yeni", inceleniyor: "İnceleniyor", cozuldu: "Çözüldü" },
    categories: { sikayet: "Şikayet", oneri: "Öneri", istek: "İstek" },
    toastUpdated: "✅ Durum güncellendi",
    errorGeneric: "Güncelleme sırasında bir hata oluştu.",
    quick: { all: "Tümü" },
    actions: { back: "Geri Dön", save: "Kaydet", openDetail: "Detayı Aç", send: "Gönder" },
    stats: { total: "Toplam", new: "Yeni", inreview: "İncelemede", resolved: "Çözüldü" },
    empty: { title: "Kayıt bulunamadı", hint: "Filtreleri temizleyip tekrar deneyin." },
    sections: { wishes: "Dilekler (İstek + Öneri)", complaints: "Şikayetler" },
    replies: {
      title: "Yanıtlar",
      placeholder: "Yanıt yazın...",
      loading: "Yükleniyor…",
      none: "Henüz yanıt yok.",
delete: "Sil",
 deleteConfirmTitle: "Silme Onayı",
 deleteConfirmContent: "Bu geri bildirimi silmek istediğinize emin misiniz?",

      sentOk: "✅ Yanıt gönderildi",
      sendErr: "❌ Yanıt gönderilemedi",
    },
  },
  en: {
    pageTitle: "📝 Feedback",
    detailTitle: "Feedback Detail",
    filters: { durum: "Status" },
    fields: {
      sender: "Sender",
      category: "Category",
      title: "Title",
      desc: "Description",
      image: "Attached Image",
      status: "Status",
    },
    statuses: { yeni: "New", inceleniyor: "In Review", cozuldu: "Resolved" },
    categories: { sikayet: "Complaint", oneri: "Suggestion", istek: "Request" },
    toastUpdated: "✅ Status updated",
    errorGeneric: "An error occurred while updating.",
    quick: { all: "All" },
    actions: { back: "Back", save: "Save", openDetail: "Open Detail", send: "Send" },
    stats: { total: "Total", new: "New", inreview: "In Review", resolved: "Resolved" },
    empty: { title: "No records", hint: "Clear filters and try again." },
    sections: { wishes: "Wishes (Request + Suggestion)", complaints: "Complaints" },
    replies: {
      title: "Replies",
      placeholder: "Write a reply...",
      loading: "Loading…",
      none: "No replies yet.",
      sentOk: "✅ Reply sent",
 delete: "Delete",
deleteConfirmTitle: "Delete Confirmation",
deleteConfirmContent: "Are you sure you want to delete this feedback?",
      sendErr: "❌ Failed to send reply",
    },
  },
  de: {
    pageTitle: "📝 Rückmeldungen",
    detailTitle: "Rückmeldung Details",
    filters: { durum: "Status" },
    fields: {
      sender: "Absender",
      category: "Kategorie",
      title: "Titel",
      desc: "Beschreibung",
      image: "Angehängtes Bild",
      status: "Status",
    },
    statuses: { yeni: "Neu", inceleniyor: "In Prüfung", cozuldu: "Gelöst" },
    categories: { sikayet: "Beschwerde", oneri: "Vorschlag", istek: "Anfrage" },
    toastUpdated: "✅ Status aktualisiert",
    errorGeneric: "Beim Aktualisieren ist ein Fehler aufgetreten.",
    quick: { all: "Alle" },
    actions: { back: "Zurück", save: "Speichern", openDetail: "Details öffnen", send: "Senden" },
    stats: { total: "Gesamt", new: "Neu", inreview: "In Prüfung", resolved: "Gelöst" },
    empty: { title: "Keine Einträge", hint: "Filter zurücksetzen und erneut versuchen." },
    sections: { wishes: "Wünsche (Anfrage + Vorschlag)", complaints: "Beschwerden" },
    replies: {
      title: "Antworten",
      placeholder: "Antwort schreiben...",
      loading: "Wird geladen…",
      none: "Noch keine Antworten.",
delete: "Löschen",
deleteConfirmTitle: "Löschbestätigung",
deleteConfirmContent: "Möchten Sie dieses Feedback wirklich löschen?",
      sentOk: "✅ Antwort gesendet",
      sendErr: "❌ Antwort konnte nicht gesendet werden",
    },
  },
};


// ⬇️ Ayarlar sayfasındakiyle aynı mantık (localStorage: "app_lang")
function useUiTexts() {
  const [uiLang, setUiLang] = useState(
    () => (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase()
  );

  useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  return T[ALLOWED.includes(uiLang) ? uiLang : "tr"];
}

/* ================= CHOICES ================= */
function useChoices() {
  const TT = useUiTexts();
  const DURUMLAR = useMemo(
    () => [
      { id: "Yeni", name: TT.statuses.yeni },
      { id: "İnceleniyor", name: TT.statuses.inceleniyor },
      { id: "Çözüldü", name: TT.statuses.cozuldu },
    ],
    [TT]
  );
  const KATEGORILER = useMemo(
    () => [
      { id: "Şikayet", name: TT.categories.sikayet },
      { id: "Öneri", name: TT.categories.oneri },
      { id: "İstek", name: TT.categories.istek },
    ],
    [TT]
  );
  return { DURUMLAR, KATEGORILER, TT };
}

/* ================= GÖRSEL ================= */
const statusColor = (status) =>
  status === "Çözüldü" ? "#10b981" : status === "İnceleniyor" ? "#f59e0b" : "#ef4444";

const CategoryChip = ({ value, TT }) => {
  const color =
    value === "Şikayet"
      ? "error"
      : value === "Öneri"
      ? "info"
      : value === "İstek"
      ? "warning"
      : "default";

  const label =
    value === "Şikayet"
      ? TT.categories.sikayet
      : value === "Öneri"
      ? TT.categories.oneri
      : value === "İstek"
      ? TT.categories.istek
      : value;

  return (
    <Chip
      size="medium"
      label={label}
      color={color}
      variant="outlined"
      sx={{ fontSize: 14, px: 1, fontWeight: 700 }}
    />
  );
};


const StatusChip = ({ value, TT }) => {
  const color =
    value === "Çözüldü"
      ? "success"
      : value === "İnceleniyor"
      ? "warning"
      : "error";

  const label =
    value === "Yeni"
      ? TT.statuses.yeni
      : value === "İnceleniyor"
      ? TT.statuses.inceleniyor
      : value === "Çözüldü"
      ? TT.statuses.cozuldu
      : value;

  return (
    <Chip
      size="medium"
      label={label}
      color={color}
      variant="filled"
      sx={{ fontSize: 14, px: 1, fontWeight: 700 }}
    />
  );
};


const BigStat = ({ title, value, gradient }) => (
  <Paper
    sx={{
      p: 3,
      borderRadius: 3,
      color: "#fff",
      background: gradient,
      boxShadow: "0 10px 24px rgba(0,0,0,0.25)",
      minHeight: 120,
    }}
  >
    <Typography variant="h5" sx={{ mt: 0.5, fontWeight: 800, lineHeight: 1 }}>
      {title}
    </Typography>
    <Typography variant="h2" sx={{ mt: 1, fontWeight: 900, lineHeight: 1 }}>
      {value}
    </Typography>
  </Paper>
);

const BigToggle = ({ value, onChange, TT }) => (
  <ToggleButtonGroup
    size="large"
    exclusive
    value={value}
    onChange={onChange}
    sx={{
      "& .MuiToggleButton-root": {
        fontSize: 16,
        px: 2.5,
        py: 1.5,
        borderRadius: 2,
        fontWeight: 800,
      },
      gap: 1,
    }}
  >
    <ToggleButton value="ALL" sx={{ bgcolor: "#1f2937", color: "#fff" }}>
      {TT.quick.all}
    </ToggleButton>
    <ToggleButton value="Yeni" sx={{ bgcolor: "#ef4444", color: "#fff" }}>
      {TT.statuses.yeni}
    </ToggleButton>
    <ToggleButton value="İnceleniyor" sx={{ bgcolor: "#f59e0b", color: "#111827" }}>
      {TT.statuses.inceleniyor}
    </ToggleButton>
    <ToggleButton value="Çözüldü" sx={{ bgcolor: "#10b981", color: "#0b1220" }}>
      {TT.statuses.cozuldu}
    </ToggleButton>
  </ToggleButtonGroup>
);

const ColoredTabButton = ({ active, color, children, onClick, badge }) => (
  <Badge
    badgeContent={badge}
    color="error"
    invisible={!badge}
    sx={{ "& .MuiBadge-badge": { fontSize: 12, height: 22, minWidth: 22 } }}
  >
    <Button
      variant={active ? "contained" : "outlined"}
      onClick={onClick}
      sx={{
        fontSize: 18,
        fontWeight: 900,
        textTransform: "none",
        px: 3,
        py: 1.5,
        borderRadius: 2,
        ...(active
          ? { bgcolor: color, color: "#0b1220" }
         : { borderColor: color, color: color }),

      }}
    >
      {children}
    </Button>
  </Badge>
);

/* -------- ÜST: Özet + Büyük hızlı filtre -------- */
const ListHeader = () => {
  const { data = [], isLoading, filterValues, setFilters } = useListContext();
  const { TT } = useChoices();

  const counts = useMemo(() => {
    const c = { total: data.length, yeni: 0, inc: 0, coz: 0 };
    data.forEach((r) => {
      if (r.durum === "Yeni") c.yeni += 1;
      else if (r.durum === "İnceleniyor") c.inc += 1;
      else if (r.durum === "Çözüldü") c.coz += 1;
    });
    return c;
  }, [data]);

  const current = filterValues?.durum || "ALL";
  const handleQuick = (_, val) => {
    if (!val || val === "ALL") setFilters({ ...filterValues, durum: undefined }, {});
    else setFilters({ ...filterValues, durum: val }, {});
  };

  return (
    <Box sx={{ px: 2, pt: 2, pb: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Stack direction="row" spacing={2}>
            <BigStat
              title={TT.stats.total}
              value={isLoading ? "…" : counts.total}
              gradient="linear-gradient(135deg,#3b82f6,#9333ea)"
            />
            <BigStat
              title={TT.stats.new}
              value={isLoading ? "…" : counts.yeni}
              gradient="linear-gradient(135deg,#ef4444,#f97316)"
            />
            <BigStat
              title={TT.stats.inreview}
              value={isLoading ? "…" : counts.inc}
              gradient="linear-gradient(135deg,#f59e0b,#fbbf24)"
            />
            <BigStat
              title={TT.stats.resolved}
              value={isLoading ? "…" : counts.coz}
              gradient="linear-gradient(135deg,#10b981,#34d399)"
            />
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: 3,
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 900 }}>
              {TT.filters.durum}
            </Typography>
            <BigToggle value={current} onChange={handleQuick} TT={TT} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

const ListActions = (props) => (
  <TopToolbar>
    <ExportButton {...props} />
  </TopToolbar>
);

const EmptyState = () => {
  const { TT } = useChoices();
  return (
    <Paper sx={{ m: 4, p: 6, textAlign: "center", opacity: 0.9, borderRadius: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 800 }}>{TT.empty.title}</Typography>
      <Typography variant="body1" sx={{ mt: 1, fontSize: 16 }}>{TT.empty.hint}</Typography>
    </Paper>
  );
};

/* ============ Kart ============ */
const CardItem = ({ r, TT, onOpenDetail }) => (
<Paper
  elevation={0}
  sx={{
    p: 3,
    borderRadius: 3,
    backgroundColor: "#f8f9fa",   // açık gri
    color: "#1f2937",             // siyaha yakın gri yazı
    border: "1px solid #d1d5db",
    position: "relative",
    overflow: "hidden",
   "&:before": {
  content: '""',
  position: "absolute",
  left: 0,
  top: 0,
  bottom: 0,
  width: 8,
  background:
    r.kategori === "Şikayet"
      ? "#ff7f7f"       // Açık kırmızı – Şikayetler artık net görünüyor
      : statusColor(r.durum),
},

  }}
>


    <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
      <Box sx={{ minWidth: 0, pr: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
<CategoryChip value={r.kategori} TT={TT} />
<StatusChip value={r.durum} TT={TT} />
          <Chip
            size="small"
            variant="outlined"
            label={new Date(r.tarih).toLocaleString()}
            sx={{ fontSize: 12, fontWeight: 700 }}
          />
        </Stack>
        <Typography variant="h6" sx={{ fontWeight: 900, fontSize: 22 }} noWrap>
          {r.baslik || "-"}
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.95, mt: 1, fontSize: 17, lineHeight: 1.6 }}>
          {r.aciklama || "-"}
        </Typography>
        {r.gonderen ? (
          <Typography variant="subtitle2" sx={{ mt: 1.25, display: "block", opacity: 0.85, fontWeight: 800 }}>
            {TT.fields.sender}: {r.gonderen}
          </Typography>
        ) : null}
      </Box>
      <Stack alignItems="flex-end" spacing={1}>
        {r.resim ? (
          <Box
            component="img"
            src={r.resim}
            alt="resim"
            sx={{
              width: 160,
              height: 105,
              objectFit: "cover",
              borderRadius: 2,
              border: "1px solid rgba(255,255,255,0.08)",
            }}
            onError={(e) => (e.currentTarget.style.display = "none")}
          />
        ) : null}
        <RecordContextProvider value={r}>
          <Button
            size="large"
            variant="contained"
            onClick={() => onOpenDetail(r)}
            startIcon={<OpenInNewIcon />}
            sx={{
              mt: 1,
              fontWeight: 900,
              fontSize: 16,
              textTransform: "none",
              borderRadius: 2,
              bgcolor:
                r.durum === "Yeni"
                  ? "#ef4444"
                  : r.durum === "İnceleniyor"
                  ? "#f59e0b"
                  : "#10b981",
              "&:hover": {
                opacity: 0.9,
                bgcolor:
                  r.durum === "Yeni"
                    ? "#dc2626"
                    : r.durum === "İnceleniyor"
                    ? "#d97706"
                    : "#059669",
              },
            }}
          >
            {TT.actions.openDetail}
          </Button>
        </RecordContextProvider>
      </Stack>
    </Stack>
  </Paper>
);

const Section = ({ title, items, TT, onOpenDetail }) => {
  if (!items?.length) return null;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h5" sx={{ mb: 1.5, fontWeight: 900 }}>
        {title}{" "}
        <Typography component="span" variant="body1" sx={{ opacity: 0.8 }}>
          ({items.length})
        </Typography>
      </Typography>
      <Grid container spacing={2.5}>
        {items.map((r) => (
          <Grid item xs={12} md={6} key={r.id}>
            <CardItem r={r} TT={TT} onOpenDetail={onOpenDetail} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

/* ============ İçerik + Sekmeler ============ */
const KartIcerik = ({ tab, setTab, TT }) => {
  const { data = [] } = useListContext();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const [update] = useUpdate();

  const dilek = useMemo(
    () => data.filter((r) => ["İstek", "Öneri"].includes(r.kategori)),
    [data]
  );
  const sikayet = useMemo(() => data.filter((r) => r.kategori === "Şikayet"), [data]);

  const onOpenDetail = (r) => {
    if (r.durum === "Yeni") {
      update(
        "geribildirimler",
        { id: r.id, data: { durum: "İnceleniyor" }, previousData: r },
        {
          onSuccess: () => {
            refresh();
            redirect(`/geribildirimler/${r.id}`);
          },
        }
      );
    } else {
      redirect(`/geribildirimler/${r.id}`);
    }
  };

  return (
    <Box sx={{ px: 2, pb: 4 }}>
      <Stack direction="row" spacing={1.5} sx={{ mb: 2 }}>
        <ColoredTabButton
          active={tab === "dilek"}
          color="#60a5fa"
          onClick={() => setTab("dilek")}
          badge={dilek.filter((r) => r.durum === "Yeni").length}
        >
          {TT.sections.wishes} ({dilek.length})
        </ColoredTabButton>

      <ColoredTabButton
  active={tab === "sikayet"}
  color="#dc2626"
  onClick={() => setTab("sikayet")}
  badge={sikayet.filter((r) => r.durum === "Yeni").length}
>

        >
          {TT.sections.complaints} ({sikayet.length})
        </ColoredTabButton>
      </Stack>

      {tab === "dilek" && (
        <Section
          title={TT.sections.wishes}
          items={dilek}
          TT={TT}
          onOpenDetail={onOpenDetail}
        />
      )}
      {tab === "sikayet" && (
        <Section
          title={TT.sections.complaints}
          items={sikayet}
          TT={TT}
          onOpenDetail={onOpenDetail}
        />
      )}
    </Box>
  );
};

/* ===================== LIST (Kart Görünüm) ===================== */
export const GeriBildirimlerPage = (props) => {
  const { TT } = useChoices();
  const refresh = useRefresh();

  // 10 sn’de bir otomatik yenileme
  useEffect(() => {
    const id = setInterval(() => refresh(), 10000);
    return () => clearInterval(id);
  }, [refresh]);

  // Flutter deep link: ?tab=dilek | sikayet
  const [tab, setTab] = useState("dilek");
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const t = (sp.get("tab") || "").toLowerCase();
    if (["dilek", "sikayet"].includes(t)) setTab(t);
  }, []);

  return (
  <List
  {...props}
  title={TT.pageTitle}
  perPage={50}
  sort={{ field: "tarih", order: "DESC" }}
  actions={<ListActions />}
  empty={<EmptyState />}
 sx={{
  backgroundColor: "#e5e7eb",        // açık gri
  "& .RaList-content": { backgroundColor: "#e5e7eb" },
  "& .RaList-main": { backgroundColor: "#e5e7eb" },
}}

>

      <GlobalStyles
        styles={{
body: { backgroundColor: "#e5e7eb" },
          "*": { fontSize: "17px" },
        }}
      />
      <ListHeader />
      <KartIcerik tab={tab} setTab={setTab} TT={TT} />
    </List>
  );
};

/* ===================== EDIT ===================== */
const EditToolbar = ({ TT }) => {
  const redirect = useRedirect();

  return (
    <RaToolbar
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      {/* SOL – SİL */}
 <DeleteButton
  mutationMode="pessimistic"
  label={TT.replies.delete}
  confirmTitle={TT.replies.deleteConfirmTitle}
  confirmContent={TT.replies.deleteConfirmContent}
  sx={{
    fontSize: 16,
    fontWeight: 900,
    borderRadius: 2,
  }}
/>



      {/* SAĞ – GERİ + KAYDET */}
      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          onClick={() => redirect("/geribildirimler")}
          sx={{ fontSize: 16, fontWeight: 900 }}
        >
          {TT.actions.back}
        </Button>

        <SaveButton
          label={TT.actions.save}
          sx={{ "& .MuiButton-root": { fontSize: 16, fontWeight: 900 } }}
        />
      </Stack>
    </RaToolbar>
  );
};

/* === Yanıtlar Paneli (konuşma alanı) === */
const RepliesPanel = ({ TT, onFirstReplySetInceleme }) => {
  const record = useRecordContext();
  const dp = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");

  const load = useCallback(() => {
    if (!record?.id) return;
    setLoading(true);
    dp.getList("geribildirim_yanitlari", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "tarih", order: "DESC" },
      filter: { geribildirim_id: record.id },
    })
      .then((res) => setItems(res?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [dp, record?.id]);

  useEffect(() => {
    load();
  }, [load]);

  const send = async () => {
    if (!text.trim()) return;
    try {
      await dp.create("geribildirim_yanitlari", {
        data: { geribildirim_id: record.id, metin: text.trim() },
      });
      setText("");
      if (record?.durum === "Yeni" && typeof onFirstReplySetInceleme === "function") {
        await onFirstReplySetInceleme(record);
      }
      load();
      refresh();
      notify(TT.replies.sentOk);
    } catch (e) {
      notify(TT.replies.sendErr, { type: "warning" });
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, mt: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 900, mb: 2 }}>
        {TT.replies.title}
      </Typography>

      <Stack spacing={1.5} sx={{ maxHeight: 260, overflow: "auto", pr: 1 }}>
        {loading ? (
          <Typography variant="body2">{TT.replies.loading}</Typography>
        ) : items.length === 0 ? (
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {TT.replies.none}
          </Typography>
        ) : (
          items.map((m) => (
          

<Box
  key={m.id}
  sx={{
    p: 2,
    borderRadius: 2,
    bgcolor: "#E0ECFF",
    border: "1px solid #F97316",
    mb: 1.5,
  }}
>
  <Typography
    variant="body1"
    sx={{
      whiteSpace: "pre-wrap",
      color: "#1f2937",   // ✔️ Koyu gri, net okunur
      fontSize: 16,
      fontWeight: 600,
    }}
  >
    {m.metin}
  </Typography>




  <Typography
    variant="caption"
    sx={{
      mt: 0.5,
      display: "block",
      color: "#64748b",            // Gri tarih
      fontWeight: 600,
    }}
  >
    {new Date(m.tarih).toLocaleString()}
  </Typography>
</Box>




          ))
        )}
      </Stack>

      <Stack direction="row" spacing={1.5} sx={{ mt: 2 }}>
        <TextFieldMUI
          placeholder={TT.replies.placeholder}
          value={text}
          onChange={(e) => setText(e.target.value)}
          fullWidth
          multiline
          minRows={1}
        />
        <Button
          variant="contained"
          size="large"
          onClick={send}
          sx={{ fontWeight: 900, borderRadius: 2 }}
        >
          {TT.actions.send}
        </Button>
      </Stack>
    </Paper>
  );
};

const GeriBildirimEditInner = ({ TT, DURUMLAR, KATEGORILER }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const [update] = useUpdate();

  const onSuccess = () => {
    notify(TT.toastUpdated);
    redirect("/geribildirimler");
  };
  const onError = (e) => {
    const msg = e?.message || TT.errorGeneric;
    notify(`❌ ${msg}`, { type: "warning" });
  };

  const makeIncelemeIfNew = async (r) => {
    const rec = r || record;
    if (!rec?.id || rec?.durum !== "Yeni") return;
    await update(
      "geribildirimler",
      { id: rec.id, data: { durum: "İnceleniyor" }, previousData: rec },
      {}
    );
    refresh();
  };

  return (
    <SimpleForm toolbar={<EditToolbar TT={TT} />} mutationOptions={{ onSuccess, onError }}>
      <Paper variant="outlined" sx={{ p: 3, mb: 3, borderRadius: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            

<TextInput
  source="baslik"
  label={TT.fields.title}
  disabled
  fullWidth
  sx={{ "& .MuiInputBase-input": { fontSize: 18 } }}
/>

<TextField
  source="gonderen"
  label={TT.fields.sender}
  fullWidth
  sx={{ mt: 2, fontSize: 18 }}
/>


            <SelectInput
              source="kategori"
              label={TT.fields.category}
              choices={KATEGORILER}
              disabled
              fullWidth
              sx={{ mt: 2 }}
            />
            <TextInput
              source="aciklama"
              label={TT.fields.desc}
              multiline
              disabled
              fullWidth
              sx={{ mt: 2, "& textarea": { fontSize: 16, lineHeight: 1.6 } }}
            />

            {/* Konuşma Alanı */}
            <RepliesPanel TT={TT} onFirstReplySetInceleme={makeIncelemeIfNew} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper variant="outlined" sx={{ p: 2, height: "100%", borderRadius: 3 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 900 }}>
                {TT.fields.image}
              </Typography>
              <ImageField
                source="resim"
                sx={{ "& img": { borderRadius: 2, width: "100%" } }}
              />
              <Divider sx={{ my: 2 }} />
              <SelectInput
                source="durum"
                label={TT.fields.status}
                choices={DURUMLAR}
                fullWidth
              />
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </SimpleForm>
  );
};

export const GeriBildirimEdit = (props) => {
  const { DURUMLAR, KATEGORILER, TT } = useChoices();
  return (
    <Edit
      {...props}
      title={TT.detailTitle}
      mutationMode="pessimistic"
      sx={{ "& .RaEdit-main": { maxWidth: 1200, margin: "0 auto" } }}
    >
      <GeriBildirimEditInner
        TT={TT}
        DURUMLAR={DURUMLAR}
        KATEGORILER={KATEGORILER}
      />
    </Edit>
  );
};
